module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_3.c17ae27d.png";